import React from "react";
import { Skeleton, Box, Flex, Grid } from "@chakra-ui/react";

const ItemBoxSkeleton = () => {
  const repeat = 12;
  return (
    <Grid templateColumns="repeat(3, 1fr)" gap={3}>
      {[...Array(repeat)].map((elementInArray, index) => (
        <Box key={index}>
          <Flex justify="space-between">
            <Skeleton
              borderWidth="1px"
              borderRadius="lg"
              height="40px"
              width="400px"
            />
          </Flex>
        </Box>
      ))}
    </Grid>
  );
};

export default ItemBoxSkeleton;
